export const breadcrumbs = [
    {
        redirect: "/admin",
        title: "Home",
    },
    {
        redirect: "",
        title: "Successware Pay",
    }
];

export const initialCompanyDetails = {
    companyId: "",
    staxEnable: false,
    masterId: 0,
    companyDetail: {
        id: "",
        companyName: "",
        streetAddress1: "",
        streetAddress2: "",
        city: "",
        country: "",
        state: "",
        zipCode: "",
        phoneNumber: "",
        createdOn: "",
        responseMessage: "",
        logoBucketId: ""
    },
    achPaymentDetail: {
        enable: false,
        authKey: "",
        xwebId: "",
        terminalId: "",
        staxEnable: false,
        merchantId: "",
        webToken: "",
        apikey: "",
    },
    ccPaymentDetail: {
        enable: false,
        authKey: "",
        xwebId: "",
        terminalId: "",
        staxEnable: false,
        merchantId: "",
        webToken: "",
        apikey: "",
    }
}

export const COMPANY_SELECTOR_LABEL = "Choose a company";